import { CommonEnums } from '../../common.enums';

export class Venn_Grp_Attr {
    venn_Grp_Id: number;
    prv_Inst_Id: number;
    lnk_Attr_Id: number;
    lnk_Obj_Id: number;
    srt_Order: number;
    venn_Inst_Id: number;
    dxMp_Id: number;
    // valid_Cd: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults(): void {
        this.venn_Grp_Id = CommonEnums.defaults.LONG_VAL;
        this.prv_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Attr_Id = CommonEnums.defaults.LONG_VAL;
        this.lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.venn_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        // this.valid_Cd = CommonEnums.defaults.DEFAULT_VALID_CD_VAL;
    }

    static parse(venn_Grp_AttrTmp: Venn_Grp_Attr): Venn_Grp_Attr {
        let venn_Grp_Attr: Venn_Grp_Attr = new Venn_Grp_Attr();
        venn_Grp_Attr.copyFrom(venn_Grp_AttrTmp);
        return venn_Grp_Attr;
    }

    getPrimaryKey(): string {
        return this.venn_Grp_Id + '.' + this.lnk_Attr_Id + '.' + this.lnk_Obj_Id + '.' + this.venn_Inst_Id + '.' + this.dxMp_Id + '.' + this.srt_Order;
    }

    copy(): Venn_Grp_Attr {
        let venn_Grp_AttrTmp: Venn_Grp_Attr = new Venn_Grp_Attr();

        venn_Grp_AttrTmp.venn_Grp_Id = this.venn_Grp_Id;
        venn_Grp_AttrTmp.prv_Inst_Id = this.prv_Inst_Id;
        venn_Grp_AttrTmp.lnk_Attr_Id = this.lnk_Attr_Id;
        venn_Grp_AttrTmp.lnk_Obj_Id = this.lnk_Obj_Id;
        venn_Grp_AttrTmp.srt_Order = this.srt_Order;
        venn_Grp_AttrTmp.venn_Inst_Id = this.venn_Inst_Id;
        venn_Grp_AttrTmp.dxMp_Id = this.dxMp_Id;

        return venn_Grp_AttrTmp
    }

    copyFrom(venn_Grp_AttrTmp: Venn_Grp_Attr): void {
        this.venn_Grp_Id = venn_Grp_AttrTmp.venn_Grp_Id;
        this.prv_Inst_Id = venn_Grp_AttrTmp.prv_Inst_Id;
        this.lnk_Attr_Id = venn_Grp_AttrTmp.lnk_Attr_Id;
        this.lnk_Obj_Id = venn_Grp_AttrTmp.lnk_Obj_Id;
        this.srt_Order = venn_Grp_AttrTmp.srt_Order;
        this.venn_Inst_Id = venn_Grp_AttrTmp.venn_Inst_Id;
        this.dxMp_Id = venn_Grp_AttrTmp.dxMp_Id;
    }

    compare(venn_Grp_AttrTmp: Venn_Grp_Attr): string {
        let venn_Grp_AttrString: string = this.toString(false);
        let venn_Grp_AttrTmpString: string = venn_Grp_AttrTmp.toString(false);

        if (venn_Grp_AttrString != venn_Grp_AttrTmpString) {
            return venn_Grp_AttrString + ', ' + venn_Grp_AttrTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Venn_Grp_Attr [venn_Grp_Id=" + this.venn_Grp_Id + ", prv_Inst_Id=" + this.prv_Inst_Id +
            ", lnk_Attr_Id=" + this.lnk_Attr_Id + ", lnk_Obj_Id=" + this.lnk_Obj_Id + ", srt_Order=" + this.srt_Order +
            ", venn_Inst_Id=" + this.venn_Inst_Id + ", dxMp_Id=" + this.dxMp_Id;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}